import { styled } from '@mui/system';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import SaveIcon from '@mui/icons-material/Save';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    width: '35%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minHeight: '100%',
      margin: 0
    }
  }
}));

export const StyledIconButton = styled(IconButton)({
  padding: 0,
  color: 'white'
});

export const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  color: 'white',
  backgroundColor: theme.palette.secondary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: 0,
  [theme.breakpoints.down('sm')]: {
    padding: 0
  },
  '& div': {
    boxShadow: 'none'
  }
}));

// AddressbookDialogButton
export const ButtonCtn = styled('div')(({ theme }) => ({
  margin: '8px 0 28px 16px',
  borderRadius: '4px',
  [theme.breakpoints.down('sm')]: {
    margin: '8px 0 0 16px'
  }
}));

export const DialogButton = styled(Button)(({ theme }) => ({
  padding: 5,
  minWidth: 40,
  border: '1px solid rgba(0, 0, 0, 0.23)',
  [theme.breakpoints.down('sm')]: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }
}));

export const StyledSaveIcon = styled(SaveIcon, {
  shouldForwardProp: prop => prop !== 'isDisabled'
})(({ theme, isDisabled }) => ({
  color: isDisabled ? '#00000042' : theme.palette.secondary.main
}));

// EmptyAddressbooksMsg
export const EmptyMessageCtn = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(3),
  paddingTop: theme.spacing(3),
  textAlign: 'center'
}));

export const CreateAddressbookBtn = styled(Button)(({ theme }) => ({
  padding: theme.spacing(2)
}));

export const AddButtonLabel = styled('span')({
  color: 'rgba(0, 0, 0, 0.87)',
  marginLeft: 4
});
